import { useEffect, useState } from "react";
import { MapPin, ArrowRight, Building2 } from "lucide-react";

import { Link } from "react-router-dom";
import api from "../api/api";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";


export default function PopularDestinations() {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/destinations")
            .then((response) => {
                setDestinations(response.data);
            })
            .catch((error) => {
                console.error("Error fetching destinations:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);


    if (loading) {
        return (
            <FeaturedLoader
                title="Loading destinations"
                subtitle="Discovering the best UAE locations..."
            />
        );
    }


    return (
        <section className="py-24 bg-gray-50 dark:bg-gray-950">

            <div className="container mx-auto px-6">


                {/* Section Header */}
                <div className="text-center mb-14">

                    <span
                        className="
                            inline-flex
                            items-center
                            gap-2
                            px-5
                            py-2
                            rounded-full
                            bg-[#D9BB74]/20
                            text-[#0F766E]
                            dark:text-[#D9BB74]
                            text-sm
                            font-semibold
                            mb-4
                        "
                    >
                        <Building2 size={16} />
                        Explore UAE
                    </span>


                    <h2
                        className="
                            text-4xl
                            font-bold
                            text-gray-900
                            dark:text-white
                            mb-3
                        "
                    >
                        Popular UAE Destinations
                    </h2>


                    <p
                        className="
                            max-w-2xl
                            mx-auto
                            text-gray-600
                            dark:text-gray-400
                        "
                    >
                        Discover luxury hotels, beachfront resorts and
                        unforgettable stays across UAE's most popular cities.
                    </p>

                </div>



                {/* Destination Cards */}
                <div
                    className="
                        grid
                        grid-cols-1
                        md:grid-cols-2
                        lg:grid-cols-3
                        gap-8
                    "
                >

                    {destinations.map((destination) => (

                        <Link
                            key={destination.id}
                            to={`/destination/${destination.slug}`}
                            className="
                                group
                                relative
                                overflow-hidden
                                rounded-3xl
                                shadow-lg
                                hover:shadow-2xl
                                transition-all
                                duration-500
                                hover:-translate-y-2
                            "
                        >


                            <img
                                src={`https://uaedubaihotels.com/uploads/destinations/${destination.image}`}
                                alt={destination.name}
                                className="
                                    h-80
                                    w-full
                                    object-cover
                                    transition-transform
                                    duration-700
                                    group-hover:scale-110
                                "
                            />



                            {/* Dark Overlay */}
                            <div
                                className="
                                    absolute
                                    inset-0
                                    bg-gradient-to-t
                                    from-black/90
                                    via-black/40
                                    to-transparent
                                "
                            />



                            {/* Hotel Count */}
                            <div className="absolute top-5 right-5">

                                <span
                                    className="
                                        flex
                                        items-center
                                        gap-2
                                        rounded-full
                                        bg-white/95
                                        px-4
                                        py-2
                                        text-sm
                                        font-semibold
                                        text-[#1B1B1B]
                                        shadow-lg
                                    "
                                >
                                    <Building2 size={15} />
                                    {destination.hotels_count} Hotels
                                </span>

                            </div>




                            {/* Content */}
                            <div
                                className="
                                    absolute
                                    bottom-0
                                    left-0
                                    w-full
                                    p-6
                                    text-white
                                "
                            >

                                <div
                                    className="
                                        flex
                                        items-center
                                        gap-2
                                        mb-2
                                        text-white/90
                                        text-sm
                                    "
                                >
                                    <MapPin size={16} />
                                    UAE Destination
                                </div>



                                <h3
                                    className="
                                        text-3xl
                                        font-bold
                                        mb-2
                                    "
                                >
                                    {destination.name}
                                </h3>



                                <p
                                    className="
                                        text-white/80
                                        text-sm
                                        mb-5
                                    "
                                >
                                    Explore premium hotels and exclusive
                                    deals in {destination.name}.
                                </p>




                                <div
                                    className="
        inline-flex
        items-center
        gap-3
        rounded-xl
        bg-[#0F766E]
        px-5
        py-2.5
        text-sm
        font-semibold
        text-white
        transition-all
        duration-300
        group-hover:bg-[#D9BB74]
        group-hover:text-[#1B1B1B]
    "
                                >
                                    Explore Hotels

                                    <ArrowRight
                                        size={16}
                                        className="
            transition-transform
            duration-300
            group-hover:translate-x-2
        "
                                    />

                                </div>


                            </div>


                        </Link>

                    ))}

                </div>




                {/* View All Button */}
                <div className="text-center mt-14">

                    <Link
                        to="/destinations"
                        className="
                            group
                            inline-flex
                            items-center
                            gap-3
                            rounded-2xl
                            bg-[#D9BB74]
                            px-8
                            py-3
                            text-sm
                            font-semibold
                            text-[#1B1B1B]
                            shadow-lg
                            transition-all
                            duration-300
                            hover:bg-[#0F766E]
                            hover:text-white
                            hover:scale-105
                            hover:shadow-xl
                        "
                    >

                        View All Destinations

                        <ArrowRight
                            size={18}
                            className="
                                transition-transform
                                duration-300
                                group-hover:translate-x-2
                            "
                        />

                    </Link>

                </div>


            </div>

        </section>
    );
}